import React, { useState, useEffect, useRef } from 'react';
import './MenuSection.css';
import ClubMenuCards from './ClubMenuCards';
import Package from './Package';
import Event from './Event';
import Gallery from './Gallery';
import Teaser from './Teaser';
import PartyPackageMenu from './PartyPackageMenu';
import AboutvenueDetails from './AboutvenueDetails';
import { Link } from 'react-router-dom';

export default function MenuSection({ partypackages, data, events, gallery, teasers, menus, isPartyPackage, isvenue }) {
    const [activeTab, setActiveTab] = useState('Menu');
    const sectionRefs = useRef({});

    const tabs1 = ['Menu', 'Package', 'Event', 'Gallery', 'Teaser', "About"];
    const tabs2 = ['Menu', 'Event', 'Teaser'];

    const tabs = !isPartyPackage ? tabs1 : tabs2

    const [delayedTabForContent, setDelayedTabForContent] = useState(activeTab);


    useEffect(() => {
        const timeout = setTimeout(() => {
            setDelayedTabForContent(activeTab);
        }, 100);

        return () => clearTimeout(timeout); // Clear timeout if activeTab changes quickly
    }, [activeTab]);


    const contentMap = {
        Menu: {
            heading: "You've got 500 🥕 Carrots ready to use.",
            subheading: "Use them to book your table FREE at the hottest party spots in town.",
            link: "/table-book-form"
        },
        Package: {
            heading: "Your 500 🥕 Carrots are ready – let the savings begin!",
            subheading: "🎉 Use them to book the exclusive party packages - Food, Drinks, Decor, DJs & more at unbeatable deals.",
            link: "/package-lead-form"
        },
        Event: {
            heading: "Your 500 🥕 Carrots are ready – let the party begin!",
            subheading: "🎉 Use them to explore and book exciting club events – Live DJs, Theme Nights, Special Performances & more at unbeatable deals.",
            link: "/package-lead-form"
        },
        Gallery: {
            heading: "Your 500 🥕 Carrots credited to your wallet.",
            subheading: "Enjoy tasty food, cool drinks, and a stylish vibe — see it all in these pictures.",
            link: "/table-book-form"
        },
        Teaser: {
            heading: "Your earned 500🥕Carrots – your party currency! ",
            subheading: "From live music and DJ nights to dazzling lights and vibrant crowd energy — get a real taste of the party scene.",
            link: "/table-book-form"
        },
        About: {
            heading: "You’ve got 500 🥕 Carrots in your wallet !!",
            subheading: "Feel the rhythm with live music, stunning lighting, and an unforgettable crowd atmosphere.",
            link: "/package-lead-form"
        }
    };

    const currentContent = contentMap[delayedTabForContent] || {
        heading: "Welcome to PartyWitty!",
        subheading: "Book through our app for exclusive perks.",
        link: "/"
    };



    // Map tab names to section IDs
    const idMap = {
        'Menu': 'club-menu-section',
        'Package': 'vcdp-package-section',
        'Event': 'vcdp-event-section',
        'Gallery': 'vcdp-gallery-section',
        'Teaser': 'vcdp-teaser-section',
        "About": 'vcdp-about-section'
    };

    useEffect(() => {
        const observerOptions = {
            root: null,
            threshold: Array.from({ length: 101 }, (_, i) => i / 100),
        };

        let visibleSections = {};

        const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                const id = entry.target.id;
                visibleSections[id] = entry;
            });

            const topSection = Object.values(visibleSections)
                .filter(entry => entry.isIntersecting)
                .sort((a, b) => {
                    const aTop = Math.abs(a.boundingClientRect.top);
                    const bTop = Math.abs(b.boundingClientRect.top);
                    return aTop - bTop;
                })[0];

            if (topSection) {
                const id = topSection.target.id;
                const newTab = Object.keys(idMap).find((key) => idMap[key] === id);
                if (newTab && newTab !== activeTab) {
                    setActiveTab(newTab);
                }
            }
        }, observerOptions);

        Object.values(idMap).forEach((id) => {
            const el = document.getElementById(id);
            if (el) observer.observe(el);
        });

        return () => observer.disconnect();
    }, [activeTab]);




    return (
        <div className='vcdp-MenuSection'>
            <div className="vcdp-container-section">
                {/* Tab Navbar */}
                <div className="vcdp-sec-navbar">
                    <div className='vcdp-HeroSectionBox-content'>
                        <div className='vcdp-HeroSectionBox-content-text'>
                            <h3>{currentContent.heading}</h3>
                            <h5>{currentContent.subheading}</h5>
                        </div>
                        <div className='vcdp-HeroSectionBox-content-btn'>
                            <Link to={currentContent.link}>
                                <button className='vcdp-hero-btn'>Reserve Now</button>
                            </Link>
                        </div>
                    </div>

                    <div className="vcdp-list-menu-tab">
                        <ul>
                            {tabs.map((tab) => (
                                <li
                                    key={tab}
                                    className={activeTab === tab ? 'vcdp-active' : ''}
                                    onClick={() => {
                                        setActiveTab(tab);
                                        const targetElement = document.getElementById(idMap[tab]);
                                        if (targetElement) {
                                            const offset = -140;
                                            const topPos = targetElement.getBoundingClientRect().top + window.scrollY + offset;
                                            window.scrollTo({ top: topPos, behavior: 'smooth' });
                                        }
                                    }}
                                >
                                    <span>{tab}</span>
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>

                {/* Sections */}
                {isPartyPackage ? (
                    <div className='club-menu-section' id='club-menu-section'>
                        <PartyPackageMenu menus={menus} />
                    </div>
                ) : (
                    <div className='club-menu-section' id='club-menu-section'>
                        <ClubMenuCards menus={menus} />
                    </div>
                )}

                {!isPartyPackage &&
                    <div className='vcdp-package-section' id='vcdp-package-section'>
                        <Package partypackages={partypackages} />
                    </div>
                }

                <div className='vcdp-event-section' id='vcdp-event-section'>
                    <Event events={events} clubName={data?.name} />
                </div>
                {!isPartyPackage &&
                    <div className='vcdp-gallery-section' id='vcdp-gallery-section'>
                        <Gallery gallery={gallery} />
                    </div>
                }
                <div className='vcdp-teaser-section' id='vcdp-teaser-section'>
                    <Teaser teasers={teasers} />
                </div>
                {!isPartyPackage &&
                    <div className='vcdp-about-section' id='vcdp-about-section'>
                        <AboutvenueDetails data={data} />
                    </div>
                }
            </div>
        </div>
    );
}
